export enum RegistrationErrorTypes {
  NOT_FOUND='MtbCustomerNotFoundError',
  B2B='MtbNotB2CCustomerError'
}
